import React from 'react';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { selectStyle } from '../../utils/styleUtils';
import { useForm, Controller } from 'react-hook-form'
import Select from 'react-select';
import _ from 'lodash';
import { setNotificationData } from '../../redux/global/globalReducer';
import { useDispatch } from 'react-redux';


function TrailerMaintenanceModal({
  modal,
  setModal,
  toggle,
  trailerOptions,
  trailerCreationInformation,
  setTrailerCreationInformation,
  toggleFormCancelDisplay,
  // isFormEdit,
  // formType,
  // toggleFormDisplay,
  args
}) {
  const dispatch = useDispatch();
  const { register, handleSubmit, setValue, setError, clearErrors, reset, setFocus, control, formState: { errors, isDirty } } = useForm();

  const onTrailerSelectChange = (e) => {
    setTrailerCreationInformation(e);
  }

  const openFormAndCloseModal = () => {
    if (trailerCreationInformation === null) {
      dispatch(
        setNotificationData({
          type: `error`,
          message: `Error!`,
          description: `Please select a trailer`,
        })
      );
      return
    }
    toggleFormCancelDisplay();
    toggle();
  }

  const resetValue = () => {
    setTrailerCreationInformation(null);
  }

  return (
    <>
      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle}>Create a Trailer Maintenance</ModalHeader>
        <ModalBody>
          <form className="row form-container justify-content-center align-items-center" id="TrailerMaintenance-form" >
            {/* <div className="col-6 col-sm-4 mb-2"></div> */}
            <div className="col-8 col-sm-6 mb-2">
              <label htmlFor="trailerId" className="form-label">Trailer</label>
              <div className="custom-selector">
                <Controller
                  name="trailer"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      onChange={(e) => { field.onChange(e); onTrailerSelectChange(e) }}
                      value={trailerCreationInformation}
                      options={trailerOptions}
                      className="company-select"
                      classnameprefix="react-select"
                      placeholder={'Trailer'}
                      id="trailer"
                      styles={selectStyle}
                      isclearable="true"
                      tabIndex={11}
                    />
                  )}
                />
              </div>
              <small className='form-error-message'>
                {errors?.companyName && errors.companyName.message}
              </small>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={openFormAndCloseModal}>
            Create Trailer Maintenance
          </Button>
        </ModalFooter>
      </Modal>
    </>

  )
}

export default TrailerMaintenanceModal